// scm项目无jq需改造，在pre-init里挂载
const init = () => {
    let RayCloud = window.RayCloud || {};
    let util = RayCloud.util || {};
    const getSizeOSS = function(size = 400) {
        const sizes = [30,40,50,70,100, 200, 400];
        return (
            sizes.find(item => {
                if (item >= size) {
                    return item;
                }
            }) || 400
        );
    };
    /**
     * fxg 图片处理 只适用这如下规则转换
     * // 原图
     https://p9-aio.ecombdimg.com/obj/ecom-shop-material/ALSUvYM_m_a68bfe9cdfe2d5591c194d2cb23d6f7d_sx_241137_www800-800
     // 处理后的图
     https://p9-aio.ecombdimg.com/img/ecom-shop-material/ALSUvYM_m_a68bfe9cdfe2d5591c194d2cb23d6f7d_sx_241137_www800-800~100x0_q90_b0.jpg
     */
    const parseEcombdimg = function(picPath, size){
        //默认原图是没有 文件后缀的，如果有文件后缀 不处理直接返回
        const regex = /https?:\/\/[^\s/$.?#].[^\s]*\.(jpg|jpeg|png|gif)/i;
        if(regex.test(picPath)){
            return picPath;
        }
        const imgUrl = new URL(picPath);
        let {origin,pathname} = imgUrl;
        if(pathname.indexOf('/obj/') === -1){
            return picPath;
        }else {
            pathname = pathname.replace('/obj/','/img/');
        }
        return origin + pathname + `~${size}x0_q90_b0.jpg`;
    };

    /**
     * 对来自预设域名列表的图片添加如 '_40x40.jpg' 的后缀
     * @param  {string} picPath [图片路径]
     * @param  {int} size    [尺寸，默认40]
     * @param  {string} picType [图片后缀名，默认'jpg']
     * @return {string}         [处理好的图片路径]
     */
    util.picPath = function(picPath, size, picType) {
        picPath = picPath || '/resources/css/build/images/no_pic.png';

        if (picPath.indexOf('no_pic') > -1) {
            return picPath;
        }

        size = size ? Math.round(size / 10) * 10 : 40;
        // 获取图片格式
        var regRes = /(\.png|\.jpg|\.jpeg)/.exec(picPath);
        /**
         * 优先使用传入的图片格式
         * 其次使用获取的格式
         * 如果都没有使用默认的jpg
         */
        picType = picType ? '.' + picType : regRes ? regRes[0] : '.jpg';

        var domainList = ['ecukwai.com','ecombdimg.com','img.alicdn.com', 'cbu01.alicdn.com', 'erp-storage-img','wish.com', 'jxc-storage', 'erp-storage-ram', 'my-live.slatic.net','gaoketian.oss-cn-hangzhou.aliyuncs.com', 'img.pddpic.com'];
        for (var i = 0; i < domainList.length; i++) {
            var curDomain = domainList[i];
            if (picPath.indexOf(domainList[i]) > -1) {
                switch (curDomain) {
                    // 针对wish平台
                    case 'wish.com':
                        if (size < 200) {
                            picPath = picPath.replace('-original.', '-small.');
                        }
                        break;
                    case 'erp-storage-img':
                    case 'jxc-storage':
                        let reg_1 = /@+([0-9])+w_+[0-9]+h+(.jpg|.jpeg|.png|.gif)$/i;
                        let reg_2 = /\?x-oss-process=style\/([0-9])+x+([0-9])+$/gi;
                        if (picPath.includes('@') && reg_1.test(picPath)) {
                            picPath = picPath.replace(reg_1, '');
                        } else if (reg_2.test(picPath)) {
                            picPath = picPath.replace(reg_2, '');
                        }
                        size = getSizeOSS(size);
                        picPath += `?x-oss-process=style/${size}x${size}`;
                        break;
                    case 'erp-storage-ram':
                        let reg_4 = /\?x-oss-process=image\/resize,h_+([0-9])+,m_lfit$/gi;
                        if (reg_4.test(picPath)) {
                            picPath = picPath.replace(reg_4, '');
                        }
                        picPath += `?x-oss-process=image/resize,h_${size},m_lfit`;
                        break;
                    case 'ecombdimg.com':
                        picPath = parseEcombdimg(picPath,size);
                        break;
                    case 'ecukwai.com':
                    case 'gaoketian.oss-cn-hangzhou.aliyuncs.com':
                        // KMERP-131333 业务处理
                        const picUrl = new URL(picPath);
                        const search = picUrl.search;
                        if(search.length > 0){
                            picPath = picPath.replace(search,'');
                        }
                        picPath += `?x-oss-process=image/resize,m_fill,h_${size},w_${size}`;
                        break;
                    case 'img.pddpic.com':
                        const picPathUrl = new URL(picPath);
                        const urlSearch = picPathUrl.search;
                        if (urlSearch.length > 0) {
                            picPath = picPath.replace(urlSearch, '');
                        }
                        picPath += `?imageView2/2/w/${size}/q/80`;
                        break;
                    case 'img.alicdn.com':
                    case 'cbu01.alicdn.com':
                    case 'my-live.slatic.net':
                        // 无需默认值，有些图片是没有后缀的， 比如 https://img.alicdn.com/bao/uploaded/TB1NyxYkTXYBeNkHFrdL6UiuVXa
                    // picType = '.jpg'; // 默认.jpg,

                        // 如果上传图片已经是缩略图情况，把缩略图后缀去除
                        if(picPath.includes('.jpg')){
                            picType = '.jpg';
                            picPath = picPath?.split('.jpg')[0] + picType;
                        } else if(picPath.includes('.png')){
                            picType = '.png';
                            picPath = picPath?.split('.png')[0] + picType;
                        }else if(picPath.includes('.gif')){
                            picType = '.gif';
                            picPath = picPath?.split('.gif')[0] + picType;
                        } else if(picPath.includes('.bmp')) {
                            picType = '.bmp';
                            picPath = picPath?.split('.bmp')[0] + picType;
                        } else if(picPath.includes('.jpeg')) {
                            picType = '.jpeg';
                            picPath = picPath?.split('.jpeg')[0] + picType;
                        }
                    default:
                        var suffix = '_' + size + 'x' + size; // 默认_40x40.jpg
                        picPath =
                            picPath.replace(/_\d+x{1}\d+(\.png|\.jpg|\.jpeg|\.gif)$/gi, '') +
                            suffix;
                        break;
                }
            }
        }
        return picPath;
    };

    RayCloud.util = util;
    window.RayCloud = window.RC = RayCloud;
}

export default {
    init
}
